import React from "react";
import "./Footer.css";
import Facebook from "../../../assets/logo/facebook.webp";
import Linkedin from "../../../assets/logo/linkedin.webp";
import Instagram from "../../../assets/logo/instagram.webp";
import Youtube from "../../../assets/logo/youtube.webp";
import Gmail from "../../../assets/logo/gmail.png";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">

        <div className="footer-social">
          <a
            href="https://www.linkedin.com/company/indianhospitalitynetwork/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Linkedin} className="social-logo" alt="LinkedIn" />
          </a>

          <a
            href="https://www.instagram.com/indianhospitalitynetwork/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Instagram} className="social-logo" alt="Instagram" />
          </a>

          <a
            href="https://www.facebook.com/indianhospitalitynetwork/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Facebook} className="social-logo" alt="Facebook" />
          </a>

          <a
            href="https://www.youtube.com/@ihntv-li7bc"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Youtube} className="social-logo" alt="YouTube" />
          </a>

          <a href="mailto:ihn.socialmediaa@gmail.com">
            <img src={Gmail} className="social-logo" alt="Email" />
          </a>
        </div>

        <div className="footer-email">
          <a href="mailto:ihn.socialmediaa@gmail.com">
            ihn.socialmediaa@gmail.com
          </a>
        </div>

        <div className="footer-bottom">
          <p className="text-center">
            &copy; {new Date().getFullYear()} Indian Hospitality Network. All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
